import { defineComponent } from 'vue';
import props from './props';

export default defineComponent({
  name: 'TDescriptionsItem',
  props,
});
